export default __webpack_public_path__ + "static/media/ri_refresh-line.23992726.svg";